import { loaderAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import * as XLSX from "xlsx";

export const ExportWorkoutsToExcelThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment } = getState();

    dispatch(loaderAction(true));

    dispatch(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('date_from', args?.from || '');
        formData.append('date_to', args?.to || '');
        formData.append('subscription_type', args?.subscription_type || '');
        formData.append('subscription_coach', args?.subscription_coach || '');
        formData.append('subscription_constraints', args?.subscription_constraints || '');
        formData.append('subscription_workouts_count', args?.subscription_workouts_count || '');
        formData.append('filter_user', args?.filter_user || '');
        formData.append('one_time', args?.oneTime || '0');
        formData.append('debt_workouts', args?.debtWorkouts || '0');

        const response = await api({ data: formData, link: 'export_workouts_to_excel' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response?.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }
        else if (response?.error) {
            growl({ type: 'error', message: response.message });
        }
        else if (response?.success) {
            // Проверяем наличие элементов в массиве
            if (response.workouts.length) {
                let result = [Object.keys(response.workouts[0])];
                response.workouts.forEach(elem => {
                    result.push(Object.values(elem));
                });

                const dates_interval = `${ new Date(args?.from).toLocaleDateString('ru-Ru') } − ${ new Date(args?.to).toLocaleDateString('ru-Ru') }`;
                const ws = XLSX.utils.aoa_to_sheet(result);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, dates_interval);
                XLSX.writeFile(wb, `${ dates_interval }.xlsx`);
            }
            else {
                growl({ type: 'warning', message: 'Нет записей. Укажите другие параметры поиска.' });
            }
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }
};